import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader/root';
import { useDispatch, useSelector } from 'react-redux';
import {
  createSystemUserFetchAction,
  deleteSystemUserFetchAction,
  editSystemUserFetchAction,
} from '../../../store/fetchActions/systemUserActions';
import { MdModeEdit, MdDelete, MdErrorOutline } from 'react-icons/md';
import * as Styled from '../PerfisUsuarios.styles';
import Table from '../../../components/Table/Table';
import Modal from '../../../components/Modal/Modal';
import { useForm } from 'react-hook-form';
import HybridField from '../../../components/HybridField/HybridField';
import Button from '../../../components/Button/Button';
import Tooltip from '@material-ui/core/Tooltip';
import { theme } from '../../../styles/theme';
import PhoneField from '../../../components/PhoneField/PhoneField';
import formatCPF from '../../../utils/functions/formatCPF';
import formatCNPJ from '../../../utils/functions/formatCNPJ';
import { showAlert } from '../../../store/ducks/sweetAlert';
import CPFCNPJField from '../../../components/CPFCNPJField/CPFCNPJField';
import {
  ButtonContainer,
  LoadingContainer,
  SmallerModal,
} from '../../GerenciarClientes/styles/GerenciarClientes.styles';
import { CircularProgress } from '@material-ui/core';
import ModalPassword from '../../../components/ModalPassword/ModalPassword';
const {
  mainColor,
  rbmWhite,
  warningColor,
  secondaryColor,
  dangerColor,
  rbmBlack,
} = theme.colors;

function Usuarios({ value, index }) {
  const dispatch = useDispatch();
  const [editUsuario, setEditUsuario] = useState({});
  const [isModalEditarUsuarioOpen, setIsModalEditarUsuarioOpen] =
    useState(false);
  const [isModalCriarUsuarioOpen, setIsModalCriarUsuarioOpen] = useState(false);
  const [isModalDeleteOpen, setIsModalDeleteOpen] = useState(false);
  const [isModalPasswordOpen, setIsModalPasswordOpen] = useState(false);
  const [ModalPasswordEditUser, setModalPasswordEditUser] = useState(false);
  const [deleteSystemUser, setDeleteSystemUser] = useState({
    name: '',
    id: '',
  });

  const { cobansData, loadingCobans, errorCobans, errorMessageCobans } =
    useSelector((state) => state.cobans);

  const { handleSubmit, control, reset } = useForm({
    defaultValues: editUsuario,
  });

  const {
    handleSubmit: handleCreateSystemUser,
    control: controlCreateSystemUser,
    reset: resetCreation,
  } = useForm({});

  const closeModals = () => {
    closeModalEditarUsuario();
    closeModalCriarUsuario();
    closeModalDelete();
  };
  function createUser() {
    setIsModalCriarUsuarioOpen(true);
  }
  function editUser() {
    setIsModalEditarUsuarioOpen(true);
  }

  function filterProfile(profile) {
    if (profile.PERFIL) {
      return false;
    } else {
      return true;
    }
  }

  const closeModalDelete = () => setIsModalDeleteOpen(false);
  const openModalDeleteUser = () => setIsModalDeleteOpen(true);

  const closeModalPassword = () => {
    setIsModalPasswordOpen(false);
  };
  const openModalPassword = () => setIsModalPasswordOpen(true);

  const closeModalPasswordEditUser = () => {
    setModalPasswordEditUser(false);
  };
  const openModalPasswordEditUser = () => setModalPasswordEditUser(true);

  const closeModalEditarUsuario = () => {
    reset();
    setIsModalEditarUsuarioOpen(false);
  };
  const closeModalCriarUsuario = () => {
    resetCreation();
    setIsModalCriarUsuarioOpen(false);
  };
  const callEditProfileAction = (data) => {
    data.SENHA === data.CONFIRMARSENHA
      ? dispatch(
          editSystemUserFetchAction(
            data.NOME,
            editUsuario.id,
            data.FONECEL,
            data.SENHA,
            data.EMAIL,
            editUsuario.CPFCNPJ,
            closeModals,
          ),
        )
      : dispatch(
          showAlert({
            title: 'Ops...',
            text: 'As senhas informadas não coincidem',
            icon: 'errorCobans',
          }),
        );
  };
  const callCreateSystemUserAction = (data) => {
    data.SENHA === data.CONFIRMARSENHA
      ? dispatch(createSystemUserFetchAction(data, closeModals))
      : dispatch(
          showAlert({
            title: 'Ops...',
            text: 'As senhas informadas não coincidem',
            icon: 'errorCobans',
          }),
        );
  };

  const header = [
    {
      id: 'nome',
      name: 'NOME',
      align: 'left',
    },
    {
      id: 'ações',
      name: 'AÇÕES',
      align: 'center',
    },
  ];

  const body = cobansData?.filter(filterProfile).map((perfil, index) => {
    return {
      data: [
        { info: perfil.NOME, align: 'left' },
        {
          info: (
            <Styled.Row>
              <Tooltip title="Editar Usuário">
                <Styled.IconContainer
                  onClick={() => {
                    setEditUsuario({
                      name: perfil.NOME,
                      id: perfil.ID,
                      CPFCNPJ: perfil.CPFCNPJ,
                      EMAIL: perfil.EMAIL,
                      FONECEL: perfil.FONECEL,
                    });
                    openModalPasswordEditUser();
                  }}
                  backgroundColor={'rgba(38, 36, 36, 0.1)'}
                >
                  <MdModeEdit />
                </Styled.IconContainer>
              </Tooltip>
              <Tooltip title="Remover Usuário">
                <Styled.IconContainer
                  onClick={() => {
                    setDeleteSystemUser({
                      name: perfil.NOME,
                      id: perfil.ID,
                      cpfcnpjcoban: perfil.CPFCNPJ,
                      email: perfil.EMAIL,
                      fonecel: perfil.FONECEL,
                    });
                    openModalPassword();
                  }}
                  backgroundColor={'rgba(242, 48, 5, 0.1)'}
                  color={'#F23005'}
                >
                  <MdDelete />
                </Styled.IconContainer>
              </Tooltip>
            </Styled.Row>
          ),
          align: 'center',
        },
      ],
    };
  });

  return (
    <div hidden={value !== index}>
      <Styled.ButtonContainer>
        <Styled.ButtonStatusUsers
          backgroundColor={secondaryColor}
          width={'12vw'}
          height={'3.125vw'}
          hoverBGColor={mainColor}
          color={rbmWhite}
          hoverColor={rbmBlack}
          onClick={() => createUser()}
        >
          + CRIAR USUÁRIO
        </Styled.ButtonStatusUsers>
      </Styled.ButtonContainer>
      <Modal
        open={isModalEditarUsuarioOpen}
        close={() => closeModalEditarUsuario()}
        title="Editar Usuário"
      >
        <form onSubmit={handleSubmit(callEditProfileAction)}>
          <HybridField
            control={control}
            title={'CPF'}
            value={
              editUsuario.CPFCNPJ?.length === 11
                ? formatCPF(editUsuario.CPFCNPJ)
                : formatCNPJ(editUsuario.CPFCNPJ)
            }
            disabled={true}
            width={'29.306vw'}
            margin={'0 0 1vw  0'}
            name={'CPFCNPJCOBAN'}
          />
          <HybridField
            control={control}
            title={'Nome'}
            value={editUsuario.name}
            disabled={false}
            width={'29.306vw'}
            margin={'0 0 1vw  0'}
            name={'NOME'}
          />
          <HybridField
            control={control}
            title={'Email'}
            value={editUsuario.EMAIL}
            disabled={false}
            width={'29.306vw'}
            margin={'0 0 1vw  0'}
            name={'EMAIL'}
          />
          <PhoneField
            control={control}
            title={'Telefone'}
            value={editUsuario.FONECEL}
            disabled={false}
            width={'29.306vw'}
            margin={'0 0 1vw  0'}
            name={'FONECEL'}
          />
          <HybridField
            inputProps={{ maxlength: 4 }}
            control={control}
            title={'Senha'}
            value={''}
            disabled={false}
            width={'29.306vw'}
            margin={'0 0 1vw  0'}
            name={'SENHA'}
            type={'password'}
          />
          <HybridField
            inputProps={{ maxlength: 4 }}
            control={control}
            title={'Confirmar Senha'}
            value={''}
            disabled={false}
            width={'29.306vw'}
            margin={'0 0 1vw  0'}
            name={'CONFIRMARSENHA'}
            type={'password'}
          />
          <Button
            backgroundColor={secondaryColor}
            width={'29.306vw'}
            height={'3.125vw'}
            margin={'1vw 0'}
            hoverBGColor={mainColor}
            hoverColor={rbmBlack}
            color={rbmWhite}
            type="submit"
          >
            <span>EDITAR</span>
          </Button>
        </form>
      </Modal>
      <Modal
        open={isModalCriarUsuarioOpen}
        close={() => closeModalCriarUsuario()}
        title="Criar Usuário"
      >
        <form onSubmit={handleCreateSystemUser(callCreateSystemUserAction)}>
          <CPFCNPJField
            control={controlCreateSystemUser}
            title={'CPF*'}
            value={''}
            disabled={false}
            width={'29.306vw'}
            name={'CPFCNPJCOBAN'}
          />
          <HybridField
            control={controlCreateSystemUser}
            title={'Nome*'}
            value={''}
            disabled={false}
            width={'29.306vw'}
            name={'NOME'}
          />
          <HybridField
            control={controlCreateSystemUser}
            title={'E-mail*'}
            value={''}
            disabled={false}
            width={'29.306vw'}
            name={'EMAIL'}
            type={'email'}
          />
          <PhoneField
            control={controlCreateSystemUser}
            title={'Telefone*'}
            value={''}
            disabled={false}
            width={'29.306vw'}
            name={'FONECEL'}
          />
          <HybridField
            control={controlCreateSystemUser}
            title={'Senha*'}
            value={''}
            disabled={false}
            inputProps={{ maxlength: 4 }}
            width={'29.306vw'}
            name={'SENHA'}
            type={'password'}
          />
          <HybridField
            control={controlCreateSystemUser}
            title={'Confirmar Senha*'}
            value={''}
            disabled={false}
            inputProps={{ maxlength: 4 }}
            width={'29.306vw'}
            name={'CONFIRMARSENHA'}
            type={'password'}
          />
          <Button
            backgroundColor={secondaryColor}
            width={'29.306vw'}
            height={'3.125vw'}
            margin={'2vw 0 0 0'}
            hoverBGColor={mainColor}
            hoverColor={rbmBlack}
            color={rbmWhite}
            type="submit"
          >
            <span>CRIAR</span>
          </Button>
        </form>
      </Modal>
      {loadingCobans ? (
        <LoadingContainer>
          <CircularProgress size={'5vw'} color="inherit" />
        </LoadingContainer>
      ) : (
        <Table
          loading={loadingCobans}
          error={errorCobans}
          errorMessage={errorMessageCobans}
          header={header}
          body={body}
        />
      )}
      <ModalPassword
        openModal={isModalPasswordOpen}
        closeModal={closeModalPassword}
        nextFunction={openModalDeleteUser}
      />
      <ModalPassword
        openModal={ModalPasswordEditUser}
        closeModal={closeModalPasswordEditUser}
        nextFunction={editUser}
      />
      <Modal open={isModalDeleteOpen} close={closeModalDelete}>
        <SmallerModal>
          <MdErrorOutline color={warningColor} size={'6.944vw'} />
          <h3>Excluir Usuário</h3>
          <h5>Tem certeza que deseja excluir o usuário?</h5>
          <ButtonContainer>
            <Button
              backgroundColor={rbmWhite}
              width={'13.792vw'}
              height={'3.125vw'}
              hoverBGColor={secondaryColor}
              hoverColor={rbmWhite}
              color={secondaryColor}
              onClick={() => {
                closeModalDelete();
              }}
            >
              <span>Voltar</span>
            </Button>
            <Button
              backgroundColor={secondaryColor}
              width={'13.792vw'}
              height={'3.125vw'}
              hoverBGColor={dangerColor}
              hoverColor={rbmWhite}
              color={rbmWhite}
              roleName="button-confirmar-negar"
              onClick={() =>
                dispatch(
                  deleteSystemUserFetchAction(
                    deleteSystemUser.name,
                    deleteSystemUser.id,
                    deleteSystemUser.cpfcnpjcoban,
                    deleteSystemUser.email,
                    deleteSystemUser.fonecel,
                    closeModals,
                  ),
                )
              }
            >
              <span>Remover</span>
            </Button>
          </ButtonContainer>
        </SmallerModal>
      </Modal>
    </div>
  );
}
export default hot(Usuarios);

Usuarios.propTypes = {
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
